"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _ProductDetailSectionTitle = _interopRequireDefault(require("./ProductDetailSectionTitle"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      justifyContent: 'flex-start'
    },
    title: {
      fontSize: 18,
      textTransform: 'none',
      fontWeight: 300
    },
    titleSection: {
      marginRight: theme.spacing(1),
      textTransform: theme.text.textTransformUppercase,
      fontWeight: 500,
      fontSize: 18
    }
  };
}, {
  name: 'ProductDetailSectionTitleMobile'
});

function ProductDetailSectionTitleMobile(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      collapsable = _ref.collapsable,
      product = _ref.product,
      title = _ref.title,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "collapsable", "product", "title"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  return collapsable ? /*#__PURE__*/_react.default.createElement(_ProductDetailSectionTitle.default, (0, _extends2.default)({}, rest, {
    product: product,
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.titleSection
  }, title), t(product.name))) : null;
}

process.env.NODE_ENV !== "production" ? ProductDetailSectionTitleMobile.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string,
    title: _propTypes.default.string,
    titleSection: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  collapsable: _propTypes.default.bool,
  product: _propTypes.default.shape({
    name: _propTypes.default.arrayOf(_propTypes.default.shape({}))
  }).isRequired,
  title: _propTypes.default.string
} : void 0;
ProductDetailSectionTitleMobile.defaultProps = {
  classes: undefined,
  className: undefined,
  collapsable: false,
  title: undefined
};
var _default = ProductDetailSectionTitleMobile;
exports.default = _default;